export type WordTimePayload = {
    startSec?: number;
    endSec?: number;
    srcStartSec?: number;
    srcEndSec?: number;
};

const toFiniteNumber = (value: any): number | null => {
    const n = Number(value);
    return Number.isFinite(n) ? n : null;
};

/**
 * Returns the word start time in ScriptClip-local time.
 * Prefers clip-local fields (startSec/endSec) over source-track fields (srcStartSec/srcEndSec).
 */
export function getWordStartClipTimeSec(payload: WordTimePayload | null | undefined): number | null {
    const start = toFiniteNumber(payload?.startSec);
    if (start != null) return start;
    const srcStart = toFiniteNumber(payload?.srcStartSec);
    return srcStart != null ? srcStart : null;
}

/**
 * Returns the word end time in ScriptClip-local time.
 * Prefers clip-local fields (startSec/endSec) over source-track fields (srcStartSec/srcEndSec).
 */
export function getWordEndClipTimeSec(payload: WordTimePayload | null | undefined): number | null {
    const end = toFiniteNumber(payload?.endSec);
    if (end != null) return end;
    const srcEnd = toFiniteNumber(payload?.srcEndSec);
    if (srcEnd != null) return srcEnd;
    return getWordStartClipTimeSec(payload);
}

/**
 * Returns a stable "seek target" time for the word in ScriptClip-local time.
 * Uses the midpoint when both start+end are available.
 */
export function getWordMidClipTimeSec(payload: WordTimePayload | null | undefined): number | null {
    const start = getWordStartClipTimeSec(payload);
    if (start == null) return null;
    const end = getWordEndClipTimeSec(payload);
    if (end == null) return start;
    return (start + end) / 2;
}

